import { StampedModel, ResourceFactory } from '../services/';

class Parametercategory extends StampedModel {
  public parent:      number = null;
  public name:        string = '';
  public parameters_count: number;
}

const ParametercategoryFactory = ResourceFactory.create<Parametercategory>(Parametercategory, 'parametercategory');

export { Parametercategory, ParametercategoryFactory };
